
import Vue from "vue";
import { Company } from "@/models/company";
import { ReferralService, IReferral, IReferralInvite } from "@/services/referral-service";
import AppCompanyInfoWrapper from "./CompanyInfoWrapper.vue";

export default Vue.extend({
	data(){
		return {
			broughtIn: [] as IReferral[],
			referredBy: null as IReferral | null,
			invites: [] as IReferralInvite[],
			selected: null as IReferral | null,
			rewarded: false,
			note: "",
			saving: false
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	methods: {
		formatDate(date:string|null):string{
			if (!date) return "";
			return new Date(date).toLocaleDateString();
		},
		goToCompany(id:number){
			if (!id) return;
			this.$router.push(`/companies/${id}/info`);
		},
		openReward(referral:IReferral){
			this.selected = referral;
			this.rewarded = referral.rewarded;
			this.note = referral.rewardNote || "";
		},
		async saveReward(){
			if (!this.selected) return;
			this.saving = true;
			try{
				let updated = await ReferralService.setRewarded(this.selected.id, this.rewarded, this.note);
				let index = this.broughtIn.findIndex(r => r.id == updated.id);
				if (index >= 0){
					this.$set(this.broughtIn, index, updated);
				}
				this.selected = null;
				this.$wf.notify("Referral updated.", "success", 3000, "check");
			}catch(err){
				this.$wf.notify("Could not update referral.", "error", 4000, "exclamation-triangle");
			}finally{
				this.saving = false;
			}
		},
		async load(){
			let data = await ReferralService.getCompanyReferrals(this.company.id);
			this.broughtIn = data.broughtIn;
			this.referredBy = data.referredBy;
			this.invites = data.invites;
		}
	},
	async created(){
		await this.load();
	},
	components: {
		AppCompanyInfoWrapper
	}
});
